import LegalShell from "../components/LegalShell";

export default function Datenschutz() {
  return (
    <LegalShell title="Datenschutzerklärung">
      <p className="legal-stand">Stand: August 2026</p>

      <h2>1. Verantwortlicher</h2>
      <p>Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser Website ist:</p>
      <p>
        Check&#39;in Tarife GbR<br />
        An der Alten Ziegelei 5<br />
        48157 Münster<br />
        Deutschland
      </p>
      <p>Vertreten durch die Gesellschafter Anil Dogan und Hisen Kajtazi.</p>
      <p>
        Telefon: <a href="tel:+491772356898">+49 177 2356898</a><br />
        E-Mail: <a href="mailto:info@checkin-tarife.de">info@checkin-tarife.de</a>
      </p>

      <h2>2. Allgemeine Hinweise</h2>
      <p>
        Wir verarbeiten personenbezogene Daten nur, soweit dies zur sicheren Bereitstellung unserer Website,
        zur Durchführung des unverbindlichen Tarif-Pre-Checks, zur Bearbeitung von Kontakt- und
        Rückrufanfragen sowie zur Anbahnung einer gewünschten Beratung erforderlich ist.
      </p>
      <p>
        Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder
        identifizierbare Person beziehen.
      </p>

      <h2>3. Hosting und technische Bereitstellung</h2>
      <p>
        Diese Website und die zugehörige Anwendung werden auf der Cloud-Infrastruktur der Entwicklungs- und
        Hosting-Plattform Emergent (Emergent Labs) bereitgestellt, die für Betrieb, Auslieferung und
        Datenbank auf Rechenzentren von Google (Google Compute Engine, Google LLC, betrieben in der EU durch
        Google Cloud EMEA Limited) zurückgreift. Die zugrunde liegende Datenbank (MongoDB) wird im Rahmen
        derselben Plattform als verwalteter Dienst betrieben.
      </p>
      <p>
        Bei jedem Aufruf der Website werden durch die technische Bereitstellung automatisch Zugriffsdaten
        verarbeitet, insbesondere die IP-Adresse, Datum und Uhrzeit des Zugriffs, die aufgerufene Seite bzw.
        Ressource, der verwendete Browser und dessen Version, das Betriebssystem, die Referrer-URL sowie
        technische Fehlerdaten.
      </p>
      <p>
        Zweck der Verarbeitung ist der sichere, stabile und fehlerfreie Betrieb der Website. Rechtsgrundlage
        ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse besteht in der Sicherheit, Stabilität und
        Missbrauchsverhinderung. Gewöhnliche Serverprotokolle werden – soweit keine sicherheitsbedingte
        längere Aufbewahrung erforderlich ist – auf höchstens 14 Tage begrenzt und anschließend gelöscht.
      </p>
      <p>
        Der aktuelle Serverstandort der eingesetzten Infrastruktur befindet sich in den USA (Region
        us-central1). Damit ist eine Übermittlung in ein Drittland verbunden. Die Übermittlung wird durch die
        Zertifizierung des Anbieters nach dem EU-US Data Privacy Framework bzw. durch EU-Standardvertrags­klauseln
        gemäß Art. 46 DSGVO abgesichert. Mit den eingesetzten technischen Dienstleistern bestehen
        Auftragsverarbeitungsverträge gemäß Art. 28 DSGVO.
      </p>

      <h2>4. Verschlüsselte Übertragung</h2>
      <p>
        Die Website wird vollständig über HTTPS ausgeliefert. Dadurch werden übermittelte Daten bei der
        Übertragung zwischen dem Endgerät des Besuchers und dem Server verschlüsselt.
      </p>

      <h2>5. Tarif-Pre-Check</h2>
      <p>Beim Pre-Check können abhängig vom ausgewählten Tarifbereich insbesondere folgende Angaben verarbeitet werden:</p>
      <ul>
        <li>Postleitzahl und gegebenenfalls Anschlussadresse</li>
        <li>aktueller Anbieter</li>
        <li>Grundpreis, Arbeitspreis und monatlicher Abschlag</li>
        <li>Jahresverbrauch, Haushaltsgröße oder Wohnfläche</li>
        <li>aktueller Monatspreis</li>
        <li>Anschlussart und Internetgeschwindigkeit</li>
        <li>Datenvolumen, bevorzugtes Mobilfunknetz und Anzahl der SIM-Karten</li>
        <li>Vertragsende und Smartphone-Wunsch</li>
        <li>Vor- und Nachname</li>
        <li>Telefonnummer</li>
        <li>E-Mail-Adresse</li>
        <li>bevorzugte Kontaktzeit</li>
        <li>Ergebnis und Eingaben des unverbindlichen Pre-Checks</li>
      </ul>
      <p>
        Die Verarbeitung erfolgt, um eine unverbindliche erste Einschätzung zu berechnen, das Ergebnis
        bereitzustellen und die gewünschte persönliche Beratung oder Kontaktaufnahme vorzubereiten.
      </p>
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung zur Bearbeitung der Anfrage
        und zur Durchführung vorvertraglicher Maßnahmen erforderlich ist.
      </p>
      <p>
        Der Pre-Check ist lediglich eine unverbindliche Orientierung. Es findet keine ausschließlich
        automatisierte Entscheidung mit rechtlicher oder vergleichbar erheblicher Wirkung im Sinne des
        Art. 22 DSGVO statt.
      </p>
      <p>
        Pflichtangaben sind für die Bearbeitung der Anfrage erforderlich. Freiwillige Felder sind deutlich als
        freiwillig gekennzeichnet.
      </p>

      <h2>6. Kontakt- und Rückrufanfragen</h2>
      <p>
        Bei Kontakt- und Rückrufanfragen verarbeiten wir insbesondere Name, Telefonnummer, E-Mail-Adresse,
        gewünschte Kontaktzeit, ausgewählten Tarifbereich und den Inhalt der Anfrage.
      </p>
      <p>
        Die Verarbeitung erfolgt zur Bearbeitung der Anfrage und zur Durchführung der gewünschten
        Kontaktaufnahme auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Bei sonstigen allgemeinen Anfragen kann
        die Verarbeitung ergänzend auf Art. 6 Abs. 1 lit. f DSGVO beruhen. Unser berechtigtes Interesse
        besteht in der sachgerechten Bearbeitung eingehender Anfragen.
      </p>
      <p>
        Nicht erfolgreiche beziehungsweise nicht zu einem Vertragsverhältnis führende Anfragen werden
        spätestens sechs Monate nach abschließender Bearbeitung gelöscht, sofern keine gesetzlichen Pflichten
        oder berechtigten Gründe für eine längere Aufbewahrung bestehen.
      </p>
      <p>
        Kommt ein Vertragsverhältnis zustande, werden die hierfür erforderlichen Daten entsprechend den
        gesetzlichen Aufbewahrungsfristen gespeichert.
      </p>

      <h2>7. Internes Lead-Dashboard</h2>
      <p>
        Übermittelte Pre-Check-, Kontakt- und Rückrufanfragen werden in einem geschützten internen
        Lead-Dashboard gespeichert.
      </p>
      <p>
        Zugriff erhalten ausschließlich die zwei freigeschalteten Administratoren. Die Daten werden zur
        Bearbeitung, Statusverwaltung, internen Zuordnung, Dokumentation von Notizen und zum Export
        berechtigter Geschäftsvorgänge verwendet.
      </p>
      <p>Das Dashboard ist technisch geschützt, insbesondere durch:</p>
      <ul>
        <li>persönliche Administratorkonten</li>
        <li>sichere Passwörter</li>
        <li>serverseitig ausgestellte und geprüfte Zugriffstoken zur Sitzungsverwaltung</li>
        <li>Zugriffskontrollen auf geschützte Endpunkte</li>
        <li>Schutz vor unbefugtem Zugriff</li>
        <li>Protokollierung sicherheitsrelevanter Administratorhandlungen (z. B. Veröffentlichungen von Orientierungswerten)</li>
        <li>Ausschluss aus der Suchmaschinenindexierung (noindex, nofollow) sowie aus der Sitemap</li>
      </ul>
      <p>API-Schlüssel und Zugangsdaten werden ausschließlich serverseitig gespeichert und niemals im Frontend-Code hinterlegt.</p>

      <h2>8. E-Mail-Kommunikation und IONOS</h2>
      <p>Für das geschäftliche E-Mail-Postfach verwenden wir Leistungen der:</p>
      <p>
        IONOS SE<br />
        Elgendorfer Straße 57<br />
        56410 Montabaur<br />
        Deutschland
      </p>
      <p>
        Wenn Nutzer uns per E-Mail kontaktieren oder Website-Anfragen an unser Postfach übermittelt werden,
        verarbeitet IONOS die für den E-Mail-Transport und die Bereitstellung des Postfachs erforderlichen
        Daten.
      </p>
      <p>
        Die Verarbeitung erfolgt zur Bearbeitung der jeweiligen Anfrage gemäß Art. 6 Abs. 1 lit. b DSGVO
        beziehungsweise auf Grundlage unseres berechtigten Interesses an einer zuverlässigen geschäftlichen
        Kommunikation gemäß Art. 6 Abs. 1 lit. f DSGVO.
      </p>

      <h2>9. Transaktionaler E-Mail-Versand über Resend</h2>
      <p>
        Für den automatischen Versand von Eingangsbestätigungen und internen Benachrichtigungen verwenden wir
        Resend, einen Dienst der:
      </p>
      <p>
        Plus Five Five, Inc.<br />
        2261 Market Street #5039<br />
        San Francisco, CA 94114<br />
        USA
      </p>
      <p>
        Dabei können insbesondere E-Mail-Adresse, Name, Absender- und Empfängerdaten, Betreff,
        Nachrichteninhalt sowie technische Zustellinformationen verarbeitet werden.
      </p>
      <p>
        Der Einsatz erfolgt ausschließlich für transaktionale Nachrichten im Zusammenhang mit einer konkreten
        Anfrage. Es werden keine Newsletter oder Werbenachrichten ohne eine gesonderte Rechtsgrundlage
        versendet.
      </p>
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Nachricht der Bearbeitung einer Anfrage
        dient. Für interne technische Benachrichtigungen ist Art. 6 Abs. 1 lit. f DSGVO einschlägig. Unser
        berechtigtes Interesse besteht in einer zuverlässigen und nachvollziehbaren Bearbeitung eingehender
        Anfragen.
      </p>
      <p>
        Resend verarbeitet Daten auch in den USA. Die Übermittlung wird durch die Zertifizierung nach dem
        EU-US Data Privacy Framework sowie durch die von Resend bereitgestellten EU-Standardvertragsklauseln
        abgesichert. Weitere Informationen:{" "}
        <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">Datenschutzerklärung von Resend</a>{" "}
        und{" "}
        <a href="https://resend.com/legal/dpa" target="_blank" rel="noopener noreferrer">Auftragsverarbeitungsvertrag (DPA) von Resend</a>.
      </p>
      <p>E-Mail- und Zustelldaten werden im verwendeten Resend-Tarif grundsätzlich bis zu 30 Tage vorgehalten.</p>
      <p>
        Open Tracking, Link Tracking, Marketingprofile und nicht erforderliche Empfängeranalysen sind
        deaktiviert. Interne E-Mail-Benachrichtigungen enthalten aus Gründen der Datensparsamkeit nur die für
        die Zuordnung erforderlichen Angaben (Lead-ID, Name, Telefonnummer, Tarifbereich und Eingangszeit).
        Vollständige Tarif- und Adressdaten werden ausschließlich im geschützten Dashboard eingesehen. Der
        Resend-API-Schlüssel ist ausschließlich als serverseitiges Secret gespeichert.
      </p>

      <h2>10. Telefonische Kontaktaufnahme</h2>
      <p>
        Wenn Nutzer einen Rückruf anfordern, verwenden wir die angegebene Telefonnummer ausschließlich zur
        Bearbeitung der konkreten Anfrage und zur gewünschten Beratung. Rechtsgrundlage ist Art. 6 Abs. 1
        lit. b DSGVO.
      </p>

      <h2>11. WhatsApp-Button</h2>
      <p>
        Die Website verwendet lediglich einen anklickbaren WhatsApp-Link zur Telefonnummer +49 177 2356898.
        Es wird keine WhatsApp Business API eingesetzt und es werden keine automatischen WhatsApp-Nachrichten
        versendet.
      </p>
      <p>
        Vor dem Anklicken des Links werden durch die Website keine personenbezogenen Daten an WhatsApp
        übermittelt. Erst nach dem Anklicken wird WhatsApp beziehungsweise WhatsApp Web aufgerufen. Ab diesem
        Zeitpunkt erfolgt die weitere Datenverarbeitung durch WhatsApp nach dessen eigenen
        Datenschutzbestimmungen. Der WhatsApp-Link ist als externer Dienst gekennzeichnet und verweist auf{" "}
        <a href="https://wa.me/491772356898" target="_blank" rel="noopener noreferrer">https://wa.me/491772356898</a>.
        Die Datenschutzinformationen von WhatsApp finden Sie unter{" "}
        <a href="https://www.whatsapp.com/legal/privacy-policy-eea" target="_blank" rel="noopener noreferrer">whatsapp.com/legal/privacy-policy-eea</a>.
      </p>

      <h2>12. Cookies und lokale Speicherung</h2>
      <p>Es werden keine Werbe-, Marketing- oder Analyse-Cookies eingesetzt.</p>
      <p>
        Für die Anmeldung im Adminbereich wird nach erfolgreichem Login ein technisch notwendiges
        Authentifizierungstoken im lokalen Speicher (Local Storage) des Browsers unter dem Namen
        <code> checkin_admin_token </code> abgelegt. Es dient ausschließlich der sicheren Anmeldung und
        Sitzungsverwaltung im geschützten Bereich, hat eine Gültigkeit von rund 12 Stunden und wird bei der
        Abmeldung entfernt. Ein Tracking findet darüber nicht statt.
      </p>
      <p>
        Die im Adminbereich lokal zwischengespeicherten Orientierungswerte enthalten keine personenbezogenen
        Kundendaten. Kundendaten und Leads werden nicht im Browser-Local-Storage gespeichert, sondern
        ausschließlich serverseitig in der geschützten Datenbank.
      </p>
      <p>
        Da ausschließlich technisch notwendige Speichermechanismen verwendet werden, wird kein Cookie-Banner
        angezeigt; diese Speicherungen werden transparent in dieser Datenschutzerklärung beschrieben.
      </p>

      <h2>13. Besuchermessung</h2>
      <p>
        Es werden keine Analyse-, Marketing- oder Trackingdienste eingesetzt. Dienste wie Google Analytics,
        Meta Pixel, Google Tag Manager, Hotjar oder vergleichbare Werkzeuge sind nicht eingebunden.
      </p>

      <h2>14. Empfänger personenbezogener Daten</h2>
      <p>
        Personenbezogene Daten erhalten nur diejenigen internen Stellen und technischen Dienstleister, die sie
        zur Bereitstellung der Website, zum E-Mail-Versand oder zur Bearbeitung der Anfrage benötigen.
      </p>
      <p>
        Eine automatische Übermittlung vollständiger Kundendaten an Energieversorger,
        Telekommunikationsanbieter oder sonstige Partner findet im Rahmen des Pre-Checks nicht statt.
      </p>
      <p>
        Eine spätere Weitergabe an einen ausgewählten Anbieter erfolgt nur, wenn sie für eine konkret
        gewünschte Vermittlung erforderlich ist und der Kunde zuvor transparent darüber informiert wurde.
      </p>

      <h2>15. Speicherdauer</h2>
      <p>Wir speichern personenbezogene Daten nur so lange, wie dies für den jeweiligen Zweck erforderlich ist.</p>
      <p>
        Nicht erfolgreiche Anfragen werden spätestens sechs Monate nach abschließender Bearbeitung gelöscht.
        Daten aus einem entstehenden Vertrags- oder Vermittlungsverhältnis werden entsprechend den
        gesetzlichen Aufbewahrungspflichten gespeichert.
      </p>
      <p>
        Gesetzliche Aufbewahrungspflichten und die Geltendmachung, Ausübung oder Verteidigung von
        Rechtsansprüchen können eine längere Speicherung erforderlich machen. Erfolglose Leads werden
        automatisch nach sechs Monaten gelöscht; die Administratoren erhalten vor einer endgültigen Löschung
        eine kurze Vorankündigung.
      </p>

      <h2>16. Rechte betroffener Personen</h2>
      <p>Betroffene Personen haben nach Maßgabe der gesetzlichen Voraussetzungen insbesondere folgende Rechte:</p>
      <ul>
        <li>Auskunft nach Art. 15 DSGVO</li>
        <li>Berichtigung nach Art. 16 DSGVO</li>
        <li>Löschung nach Art. 17 DSGVO</li>
        <li>Einschränkung der Verarbeitung nach Art. 18 DSGVO</li>
        <li>Datenübertragbarkeit nach Art. 20 DSGVO</li>
        <li>Widerspruch nach Art. 21 DSGVO</li>
        <li>Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft</li>
      </ul>
      <p>Zur Ausübung dieser Rechte genügt eine Nachricht an <a href="mailto:info@checkin-tarife.de">info@checkin-tarife.de</a>.</p>

      <h2>17. Widerspruchsrecht</h2>
      <p>
        Soweit personenbezogene Daten auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO verarbeitet werden, besteht
        das Recht, aus Gründen, die sich aus der besonderen Situation der betroffenen Person ergeben,
        Widerspruch gegen die Verarbeitung einzulegen.
      </p>

      <h2>18. Beschwerderecht</h2>
      <p>Betroffene Personen haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.</p>
      <p>Für unser Unternehmen ist grundsätzlich zuständig:</p>
      <p>
        Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen<br />
        Kavalleriestraße 2–4<br />
        40213 Düsseldorf<br />
        Deutschland<br />
        Website: <a href="https://www.ldi.nrw.de/" target="_blank" rel="noopener noreferrer">https://www.ldi.nrw.de/</a>
      </p>

      <h2>19. Aktualisierung der Datenschutzerklärung</h2>
      <p>
        Wir passen diese Datenschutzerklärung an, wenn sich die Website, die eingesetzten Dienste oder die
        gesetzlichen Anforderungen ändern.
      </p>
    </LegalShell>
  );
}
